(function () {
  function initArrivals(section) {
    if (!section || section.dataset.cbArrivalsReady === 'true') return;
    section.dataset.cbArrivalsReady = 'true';

    var tabs = Array.prototype.slice.call(section.querySelectorAll('[data-tab-trigger]'));
    var panels = Array.prototype.slice.call(section.querySelectorAll('[data-tab-panel]'));
    var viewAllLink = section.querySelector('[data-view-all-link]');
    var viewAllText = section.querySelector('[data-view-all-text]');

    if (!tabs.length || !panels.length) return;

    function updateSliderButtons(panel) {
      var track = panel.querySelector('[data-products-track]');
      var prevBtn = panel.querySelector('[data-products-prev]');
      var nextBtn = panel.querySelector('[data-products-next]');

      if (!track || !prevBtn || !nextBtn) return;

      var maxScrollLeft = track.scrollWidth - track.clientWidth;
      var currentScroll = Math.round(track.scrollLeft);

      prevBtn.classList.toggle('is-disabled', currentScroll <= 2);
      nextBtn.classList.toggle('is-disabled', currentScroll >= maxScrollLeft - 2);
    }

    function bindPanelSlider(panel) {
      if (!panel || panel.dataset.sliderBound === 'true') return;
      panel.dataset.sliderBound = 'true';

      var track = panel.querySelector('[data-products-track]');
      var prevBtn = panel.querySelector('[data-products-prev]');
      var nextBtn = panel.querySelector('[data-products-next]');
      var items = panel.querySelectorAll('.cb-arrivals__product');

      if (!track || !prevBtn || !nextBtn || items.length < 2) {
        if (prevBtn) prevBtn.style.display = 'none';
        if (nextBtn) nextBtn.style.display = 'none';
        return;
      }

      var ticking = false;

      function getScrollAmount() {
        var firstItem = items[0];
        if (!firstItem) return 0;

        var itemWidth = firstItem.getBoundingClientRect().width;
        var styles = window.getComputedStyle(track);
        var gap = parseFloat(styles.columnGap || styles.gap || 0);

        return itemWidth + gap;
      }

      function requestButtonUpdate() {
        if (ticking) return;

        ticking = true;
        window.requestAnimationFrame(function () {
          updateSliderButtons(panel);
          ticking = false;
        });
      }

      prevBtn.addEventListener('click', function () {
        track.scrollBy({
          left: -getScrollAmount(),
          behavior: 'smooth'
        });
      });

      nextBtn.addEventListener('click', function () {
        track.scrollBy({
          left: getScrollAmount(),
          behavior: 'smooth'
        });
      });

      track.addEventListener('scroll', requestButtonUpdate, { passive: true });
      updateSliderButtons(panel);
    }

    function activateTab(tab) {
      var targetId = tab.getAttribute('data-target');
      var targetPanel = section.querySelector('[data-panel-id="' + targetId + '"]');
      var tabLabel = tab.getAttribute('data-tab-label') || '';
      var tabLink = tab.getAttribute('data-tab-link') || '#';

      tabs.forEach(function (item) {
        var isActive = item === tab;
        item.classList.toggle('is-active', isActive);
        item.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });

      panels.forEach(function (panel) {
  panel.classList.remove('is-active');
  panel.hidden = true;
});

      if (targetPanel) {
  targetPanel.hidden = false;
  targetPanel.classList.add('is-active');
  bindPanelSlider(targetPanel);
  updateSliderButtons(targetPanel);
}

      if (viewAllLink) {
        viewAllLink.setAttribute('href', tabLink);
      }

      if (viewAllText) {
        viewAllText.textContent = 'VIEW ALL ' + tabLabel.toUpperCase();
      }
    }

    var activePanel = section.querySelector('.cb-arrivals__panel.is-active');
    if (activePanel) {
      bindPanelSlider(activePanel);
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        activateTab(tab);
      });
    });

    var resizeTimer;
    window.addEventListener(
      'resize',
      function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function () {
          var currentPanel = section.querySelector('.cb-arrivals__panel.is-active');
          if (currentPanel) updateSliderButtons(currentPanel);
        }, 180);
      },
      { passive: true }
    );
  }

  function bootArrivals() {
    var sections = Array.prototype.slice.call(document.querySelectorAll('[data-cb-arrivals]'));
    if (!sections.length) return;

    if (!('IntersectionObserver' in window)) {
      sections.forEach(initArrivals);
      return;
    }

    var observer = new IntersectionObserver(
      function (entries, obs) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;

          initArrivals(entry.target);
          obs.unobserve(entry.target);
        });
      },
      {
        root: null,
        rootMargin: '350px 0px',
        threshold: 0.01
      }
    );

    sections.forEach(function (section) {
      observer.observe(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootArrivals, { once: true });
  } else {
    bootArrivals();
  }
})();